import ReactECharts from 'echarts-for-react';

export default function EChart({ option, height = 360 }) {
  return (
    <ReactECharts
      option={option}
      notMerge
      lazyUpdate
      style={{ height, width: '100%' }}
    />
  );
}
